import React from 'react';
import { styled } from '../styles';
function filterCardProps(props) {
    const { noShadow, square, background, ...rest } = props;
    return rest;
}
const Card = styled(props => React.createElement("div", { ...filterCardProps(props) }))(({ background, noShadow, square, theme: { palette, shadows } }) => ({
    backgroundColor: background || palette.background.hightlight,
    boxShadow: !noShadow ? shadows[0] : '',
    borderRadius: square ? '3px 3px 3px 3px' : 'none',
}));
export default Card;
//# sourceMappingURL=Card.js.map